import React, { useEffect, useState } from 'react'

import CampaignPage from '../../index'
import ClientQuestionsView from '../component/ClientQuestionsView'

import { DropzoneWithUrl } from '../../../../../Components/Form/DropzoneWithUrl'
import { apiClient } from '../../../../../Module/API/Client'
import { updateCampaign as updateCampaignGQL } from '../../../../../Module/graphQL'
import PitchQuestionsForm from '../../../../../Components/PitchQuestionsForm/container/PitchQuestionsForm'
import getCampaignsPitchUrl from '../gql'
import useGraphQLFetch from '../../../../../Utils/Hooks/useGraphQLFetch'

const ClientQuestions = ({ match, nav, history }) => {
  const [progress, setProgress] = useState(null)
  const [pitchUrl, setPitchUrl] = useState(null)
  const [isDeleting, setIsDeleting] = useState(false)

  const { campaignId } = match.params

  const responseData = useGraphQLFetch({
    fetchFn: getCampaignsPitchUrl,
    defaultFetchArgs: campaignId,
  })

  useEffect(() => {
    if (responseData.isLoaded) {
      const pitchUrl = responseData.data.campaign.pitchUrl
      if (pitchUrl) {
        setPitchUrl(pitchUrl)
      }
    }
  }, [responseData.isLoaded])

  const onChange = async ([pitchFile]) => {
    setProgress(20)
    const pitchUrl = await apiClient.uploadPitchFile(campaignId, pitchFile)
    setProgress(75)
    var response = await updateCampaignGQL({
      campaignId,
      pitchUrl,
    })
    var result = await response.json()
    if (result.errors && result.errors[0])
      throw new Error(result.errors[0].message)
    setProgress(100)
    setPitchUrl(pitchUrl)
    setProgress(null)
  }

  const onDelete = async () => {
    setIsDeleting(true)
    var response = await updateCampaignGQL({
      campaignId,
      pitchUrl: null,
    })
    var result = await response.json()
    if (result.errors && result.errors[0])
      throw new Error(result.errors[0].message)
    setPitchUrl(null)
    setIsDeleting(false)
  }

  return (
    <CampaignPage
      active={nav}
      history={history}
      match={match}
      campaignId={campaignId}
    >
      <ClientQuestionsView
        pitchUrl={pitchUrl}
        onDelete={onDelete}
        isDeleting={isDeleting}
        fileUploader={
          <DropzoneWithUrl progress={progress} input={{ onChange }} meta={{}} />
        }
      >
        {pitchUrl && <PitchQuestionsForm campaignId={campaignId} />}
      </ClientQuestionsView>
    </CampaignPage>
  )
}

export default ClientQuestions



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/ClientQuestions/container/ClientQuestions.js